import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import "./DashboardVariableFormModal.css"
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import TextArea from "/src/components/UI/TextField/TextArea";

const DashboardVariableFormAdvancedSlide = ({ watch, register }) => {

    return (
        <>
            <div className="title_container">
                <Field label={<div>Informations <i className="fas fa-info-circle"></i></div>} listLabelClassName="field-modal" />
                <TextArea className="input full-width resize-area text_area_dashboard_form_variable"  {...register('information', { maxLength: 200 })} placeholder="Enter the complementary informations  of the variable" ></TextArea>
            </div>


            <div className="title_container">
                <Field label={<div> Regex {(watch('type') == 1 ? "" : <span className="disabled_field_message">Disabled</span>)}</div>} listLabelClassName="field-modal" />
                <TextArea  {...register('regex')} placeholder="Enter the complementary informations  of the variable" disabled={watch('type') == 1 ? false : true} className={"input full-width resize-area text_area_dashboard_form_variable " + (watch('type') == 1 ? "" : "text_area_disabled")}></TextArea>
            </div>
            <div className="title_container">
                <Field label={<div> Error message indication {(watch('type') == 1 ? "" : <span className="disabled_field_message">Disabled</span>)}</div>} listLabelClassName="field-modal" />
                <TextInput {...register('placeholder_format')} placeholder="Example : Don't insert special character" className={"input_variable_dashboard_form " + (watch('type') == 1 ? "" : "text_area_disabled")} disabled={watch('type') == 1 ? false : true}></TextInput>
            </div>
            <div style={{ display: 'flex', justifyContent:"space-between" }}>
                <div className="dashboard_advanced_parameters" onClick={() => ScrollIntoSlide(watch('type') == 3 ? "button_result" : "obligatory")}> <i className="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "0" }}></i>{watch('type') == 3 ? "Button" : "Main"} Parameters</div>
                <div className="dashboard_advanced_parameters" onClick={() => ScrollIntoSlide("conditionals")}>Conditional Parameters <i className="fas fa-arrow-right" style={{ marginRight: "10px", marginTop: "0" }}></i></div>
            </div>

        </>
    )
}
export default DashboardVariableFormAdvancedSlide 
